import React, { useContext, useEffect, useState } from "react";

/// React router dom
import { Switch, Route, Routes, useNavigate } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";
/// Dashboard
import Home from "./components/Dashboard/Home";

import { ThemeContext } from "../context/ThemeContext";
import Protect from "../store/custom-actions/ProtectRoutes";
import LogOut from "../store/custom-actions/LogoutComponent";
import NotFoundPage from "./pages/not-found-page/NotFoundPage";
import LoginPage from "./pages/login-page/LoginPage";
import ProductPage from "./pages/products-pages/ProductsPage";
import NewProductForm from "./custom-forms/product-forms/NewProductForm";
import CategoriesPage from "./pages/categories-page/CategoriesPage";
import CitiesPage from "./pages/cities-page/CitiesPage";
import CountriesPage from "./pages/countries-page/CountriesPage";
import StatesPage from "./pages/states-page/StatesPage";
import NewCouponForm from "./custom-forms/coupons/NewCouponForm";
import CouponsPage from "./pages/coupons-page/CouponsPage";
import UpdateCouponFrom from "./custom-forms/coupons/UpdateCouponForm";
import CouponUsersPage from "./pages/coupons-page/CouponsUersPage";
import UsersPage from "./pages/users-pages/UsersPage";
import UpdateProductForm from "./custom-forms/product-forms/UpdateProductForm";
import RolesPage from "./pages/roles-page/RolesPage";
import NewRoleForm from "./custom-forms/roles/NewRoleForm";
import UpdateRoleForm from "./custom-forms/roles/UpdateRoleForm";
import SingleRolePage from "./pages/roles-page/RolePermissions";
import AdminsPage from "./pages/admins-page/AdminsPage";
import NewAdminForm from "./custom-forms/admins/NewAdminForm";
import UpdateAdminMainData from "./custom-forms/admins/UpdateAdminMainData";
import ChangeAdminPassword from "./custom-forms/admins/ChangeAdminPassword";
import UpdateAdminImage from "./custom-forms/admins/UpdateAdminImage";
import AdminProfile from "./pages/admins-page/AdminProfile";
import OrdersPage from "./pages/orders-page/OrdersPage";
import NewsLettersPage from "./pages/news-letters-page/NewsLettersPage";
import InvoicePage from "./pages/orders-page/invoice-page/InvoicePage";
import BasicSettingsPage from "./custom-forms/settings-pages/BasicSettingsPage";
import HomepageSettingsPage from "./custom-forms/settings-pages/HomepageSettingsPage";
import SmtpSettingsForm from "./custom-forms/settings-pages/SmtpSettingsForm";
import TestSmtpSettingsForm from "./custom-forms/settings-pages/TestSmtpSettingsForm";
import PaymentsGatewaySettings from "./custom-forms/settings-pages/PaymentsGateway";
import OtoSettingsPage from "./custom-forms/settings-pages/OtoSettingsPage";
import MessagesPage from "./pages/contact-page/MessagesPage";
import SendNotficationPage from "./custom-forms/notfications/SendNotficationPage";
import UpdateRefundOrderPage from "./pages/orders-page/UpdateRefund";
import NewMessage from "./custom-forms/news-letters/NewMessage";
import WhatsappForm from "./custom-forms/whatsapp/WhatsappForm";
import HavNotPermissionPage from "./pages/have-not-permission-page/HaveNotPermissionPage";
import checkPermissions from "./global-functions/checkPermissionsFunc";
import LanguagesPage from "./pages/languages-page/LanguagesPage";
import UpdateLaguageWordsPage from "./pages/languages-page/UpdateLaguageWordsPage";
import UserProfile from "./pages/users-pages/UserProfile";
import SlidersPage from "./pages/sliders-page/SlidersPage";
import NewSliderForm from "./custom-forms/settings-pages/sliders-settings/NewSliderForm";
import UpdateSliderForm from "./custom-forms/settings-pages/sliders-settings/UpdateSliderForm";
import { useSelector } from "react-redux";
import Setting from "./layouts/Setting";
import CreateCategory from "./pages/categories-page/CreateCategory";
import UpdateCategoryForm from "./pages/categories-page/UpdateCategory";
import AttributesPage from "./pages/attributes-page/AttributesPage";
import NewAttributePage from "./pages/attributes-page/NewAttributePage";
import EditAttributePage from "./pages/attributes-page/EditAttributePage";
import CurrenciesPage from "./pages/currencies-page/CurrenciesPage";
import EmailTemplatesPage from "./pages/email-templates-page/EmailTemplatesPage";
import PartnersPage from "./pages/partners-page/PartnersPage";

const Markup = () => {
  const { menuToggle } = useContext(ThemeContext);
  const expire_date = window.localStorage.getItem("expire_date");
  const user = JSON.parse(window.localStorage.getItem("user"));
  const userRoleName = user && user.roleName && user.roleName.toLowerCase();
  const navigate = useNavigate();
  const { data: languageData } = useSelector((state) => state.getLanguageSettingsSlicer);
  useEffect(() => {
    if (!expire_date) {
      navigate("/login-page");
    }
  }, [navigate, expire_date]);

  const routes = [
    { url: "/", component: <Home /> },
    { url: "/dashboard", component: <Home /> },
    // products///////
    { url: "/products", component: checkPermissions("read products", <ProductPage />, <HavNotPermissionPage />) },
    {
      url: "/products/create",
      component: checkPermissions("create products", <NewProductForm />, <HavNotPermissionPage />),
    },
    {
      url: "/products/update-item/:productId",
      component: checkPermissions("update products", <UpdateProductForm />, <HavNotPermissionPage />),
    },

    // attributes///////
    {
      url: "/attributes",
      component: checkPermissions("read attributes", <AttributesPage />, <HavNotPermissionPage />),
    },
    {
      url: "/new-attribute",
      component: checkPermissions("create attributes", <NewAttributePage />, <HavNotPermissionPage />),
    },
    {
      url: "/edit-attribute/:attributeId",
      component: checkPermissions("update attributes", <EditAttributePage />, <HavNotPermissionPage />),
    },

    // categories///////
    {
      url: "/categories",
      component: checkPermissions("read categories", <CategoriesPage />, <HavNotPermissionPage />),
    },
    {
      url: "/new-category",
      component: checkPermissions("add categories", <CreateCategory />, <HavNotPermissionPage />),
    },
    {
      url: `/update-category/:catId`,
      component: checkPermissions("update categories", <UpdateCategoryForm />, <HavNotPermissionPage />),
    },

    // adresses///////
    { url: "/cities", component: checkPermissions("read addresses", <CitiesPage />, <HavNotPermissionPage />) },
    // {
    //   url: "/cities/:stateId",
    //   component: checkPermissions("read addresses", <CitiesOfStatePage />, <HavNotPermissionPage />),
    // },
    { url: "/countries", component: checkPermissions("read addresses", <CountriesPage />, <HavNotPermissionPage />) },
    { url: "/states", component: checkPermissions("read addresses", <StatesPage />, <HavNotPermissionPage />) },
    // { url: "/sub-categories", component: <SubCategoriesPage/> },

    //coupons///////
    { url: "/coupons", component: checkPermissions("read coupons", <CouponsPage />, <HavNotPermissionPage />) },
    { url: "/new-coupon", component: <NewCouponForm /> },
    {
      url: "/update-coupon/:couponId",
      component: checkPermissions("update coupons", <UpdateCouponFrom />, <HavNotPermissionPage />),
    },
    {
      url: "/coupon-users/:couponId",
      component: checkPermissions("read coupons", <CouponUsersPage />, <HavNotPermissionPage />),
    },

    //users//////
    { url: "/users", component: checkPermissions("read users", <UsersPage />, <HavNotPermissionPage />) },
    {
      url: "/user-profile/:userId",
      component: checkPermissions("read users", <UserProfile />, <HavNotPermissionPage />),
    },

    //roles
    { url: "/roles", component: checkPermissions("read roles", <RolesPage />, <HavNotPermissionPage />) },
    {
      url: "/show-role/:roleId",
      component: checkPermissions("read roles", <SingleRolePage />, <HavNotPermissionPage />),
    },
    { url: "/new-role", component: checkPermissions("create roles", <NewRoleForm />, <HavNotPermissionPage />) },
    {
      url: "/update-role/:roleId",
      component: checkPermissions("update roles", <UpdateRoleForm />, <HavNotPermissionPage />),
    },

    //admins
    { url: "/admins", component: checkPermissions("read admins", <AdminsPage />, <HavNotPermissionPage />) },
    { url: "/admin-profile", component: checkPermissions("read admins", <AdminProfile />, <HavNotPermissionPage />) },
    { url: "/new-admin", component: checkPermissions("create admins", <NewAdminForm />, <HavNotPermissionPage />) },
    {
      url: "/update-admin-main-data/:adminId",
      component: checkPermissions("update admins", <UpdateAdminMainData />, <HavNotPermissionPage />),
    },
    {
      url: "/update-admin-pass/:adminId",
      component: checkPermissions("update admins", <ChangeAdminPassword />, <HavNotPermissionPage />),
    },
    {
      url: "/update-admin-image/:adminId",
      component: checkPermissions("update admins", <UpdateAdminImage />, <HavNotPermissionPage />),
    },

    //orders
    { url: "/orders", component: checkPermissions("read orders", <OrdersPage />, <HavNotPermissionPage />) },
    {
      url: "/invoice-page/:orderId",
      component: checkPermissions("read orders", <InvoicePage />, <HavNotPermissionPage />),
    },
    {
      url: "/update-order-redfund/:orderId",
      component: checkPermissions("update orders", <UpdateRefundOrderPage />, <HavNotPermissionPage />),
    },

    //news
    {
      url: "/news-letters",
      component: checkPermissions("read newsletters", <NewsLettersPage />, <HavNotPermissionPage />),
    },
    { url: "/post-news", component: <NewMessage /> },

    //contact
    {
      url: "/contacts",
      component: checkPermissions("read contacts", <MessagesPage />, <HavNotPermissionPage />),
    },
    {
      url: "/send-notfication",
      component: checkPermissions("create notifications", <SendNotficationPage />, <HavNotPermissionPage />),
    },

    //settings
    {
      url: "/basic-settings",
      component: userRoleName === "super admin" ? <BasicSettingsPage /> : <HavNotPermissionPage />,
    },
    {
      url: "/homepage-settings",
      component: userRoleName === "super admin" ? <HomepageSettingsPage /> : <HavNotPermissionPage />,
    },
    {
      url: "/smtp-settings",
      component: userRoleName === "super admin" ? <SmtpSettingsForm /> : <HavNotPermissionPage />,
    },
    {
      url: "/test-smtp",
      component: userRoleName === "super admin" ? <TestSmtpSettingsForm /> : <HavNotPermissionPage />,
    },
    {
      url: "/payment-gateway-settings",
      component: userRoleName === "super admin" ? <PaymentsGatewaySettings /> : <HavNotPermissionPage />,
    },
    {
      url: "/oto-settings",
      component: userRoleName === "super admin" ? <OtoSettingsPage /> : <HavNotPermissionPage />,
    },
    {
      url: "/languages-settings",
      component: userRoleName === "super admin" ? <LanguagesPage /> : <HavNotPermissionPage />,
    },
    {
      url: "/single-lang/:langId",
      component: userRoleName === "super admin" ? <UpdateLaguageWordsPage /> : <HavNotPermissionPage />,
    },
    {
      url: "/sliders-settings",
      component: userRoleName === "super admin" ? <SlidersPage /> : <HavNotPermissionPage />,
    },
    { url: "/new-slider", component: userRoleName === "super admin" ? <NewSliderForm /> : <HavNotPermissionPage /> },
    { url: "/update-slider/:sliderId", component: userRoleName === "super admin" ? <UpdateSliderForm /> : <HavNotPermissionPage /> },
    
    //currencies
    { url: "/currencies", component: checkPermissions("read currencies", <CurrenciesPage />, <HavNotPermissionPage />) },
    
    //email-templates
    { url: "/email-templates", component: checkPermissions("update settings", <EmailTemplatesPage />, <HavNotPermissionPage />) },
    
    //partners
    { url: "/partners", component: checkPermissions("read partners", <PartnersPage />, <HavNotPermissionPage />) },
    
    //whatsapp
    {
      url: "/new-whatsapp-message",
      component: checkPermissions("create notifications", <WhatsappForm />, <HavNotPermissionPage />),
    },
  ];
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  // SendNotficationPage
  return (
    <>
      <div
        id={`${expire_date ? "main-wrapper" : ""}`}
        className={`${expire_date ? "show" : "mh100vh"}  ${menuToggle ? "menu-toggle" : ""}`}
      >
        {expire_date && <Nav />}
        <div
          className={`${expire_date ? "content-body" : ""} ${localStorage.getItem('langSlug') === "ar" ? "ar-mode" : "en-mode"
            }`}
          style={expire_date && { minHeight: window.screen.height - 45 }}
        >
          <div className={`${expire_date ? "container-fluid" : ""}`}>
            <Routes>
              <Route path="*" element={<NotFoundPage />} />
              <Route element={<Protect />}>
                <Route path="/login-page" element={<LoginPage />} />
              </Route>
              {routes.map((route, index) => (
                <Route key={index} path={route.url} element={route.component} />
              ))}
            </Routes>
            {expire_date && <LogOut />}
          </div>
        </div>
        {expire_date && (
          <>
            <Footer />
            {checkPermissions("update settings", <Setting />, <HavNotPermissionPage />)}
          </>
        )}
      </div>
      <ScrollToTop />
    </>
  );
};

export default Markup;
